<div class="parameter-dialog-container">
  <div class="side-popup" [ngClass]="customCssClass">

    <!-- HEADER: icon + title + close X -->
    <div class="pop-header">
      <div class="pop-header__left">
        <span class="pop-header__title" *ngIf="!customHeaderTitlePresent">{{translationsService.translate('insertParameters')}}</span>
        <span class="pop-header__title" *ngIf="customHeaderTitlePresent">{{translationsService.translate(customHeaderTitle)}}</span>
      </div>
      <div class="pop-header__close" (click)="cancelParameterDialog()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </div>
    </div>

    <!-- BODY: scrollable content area -->
    <div class="popup-inner-content">
      <div *ngIf="!isReportInUse">
        <app-sem-dynamic-control #dynComp (modelChanged)="modelChanged($event)" [url]="paramsFormUrl" [useForParams]="true"></app-sem-dynamic-control>
      </div>
      <div *ngIf="isReportInUse">
        <div>
          <div *ngFor="let parameter of reportParameters">
            <div>
              <div [ngSwitch]="parameter.DataType" *ngIf="!parameter.IsAuto">
                <div class="input-holder">
                  <div class="form-group">
                    <div class="label-holder">
                      <label>
                        <span *ngIf="!parameter.Nullable">
                        </span>{{parameter.LabelText}}
                      </label>
                    </div>
                    <div class="control-holder">
                      <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" [form]="form" *ngSwitchCase="'String'" [(ngModel)]="model[parameter.Name]"
                                    [isReadOnly]="parameter.IsReadOnly" name="{{parameter.Name}}">
                      </sem-text-box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class='btn-group btn-group-param-popup'>
          <button (click)='confirmParameterDialog()' class='accept'>Potrdi</button>
          <button (click)='cancelParameterDialog()' class='decline'>Zapri</button>
        </div>
      </div>
    </div>

  </div>
</div>
